import { configureStore } from '@reduxjs/toolkit';
import authReducer from './../src/redux/authSlice';
import propertyReducer from './../src/redux/propertySlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    property: propertyReducer
  }
});
export type RootState = ReturnType<typeof store.getState>;
export default store;
